export const setActiveSection = ({ commit }, to) => {
  commit('setActiveSection', to)
}

export const setAnimatingScrollState = ({ commit }, to) => {
  commit('setAnimatingScrollState', to)
}

export const setSiteLoaded = ({ commit }, to) => {
  commit('setSiteLoadedState', to)
}

export const setScrollLockedState = ({ commit }, to) => {
  commit('setScrollLockedState', to)
}

export const setLocale = ({commit}, to) => {
  commit('setLocale', to);
}

export const setChatOnline = ({commit}, to) => {
  commit('setChatOnline', to);
}



// WEBPACK FOOTER //
// ./src/store/actions.js